import type {
  NumericCondition,
  SetCondition,
  StateMachineData,
  TransitionV2,
  V2OrganisationConditionFieldName,
  V2PayloadCondition
} from '../ProgramStateMachine.types'

export const V2_ORGANISATION_FIELDS: readonly V2OrganisationConditionFieldName[] = [
  'country',
  'activityTags',
  'orgType',
  'id'
]

export const V2_CONDITION_TYPES = ['set', 'numeric'] as const
export const V2_MATCH_MODES = ['any', 'all'] as const

export const isV2Definition = (d: Pick<StateMachineData, 'version'>): boolean => d.version === 2

export const isNumericCondition = (c: V2PayloadCondition): c is NumericCondition => !('values' in c)

export const isSetCondition = (c: V2PayloadCondition): c is SetCondition => 'values' in c

export const isTransitionV2 = (t: { when?: unknown }): t is TransitionV2 => {
  const w = t.when as TransitionV2['when'] | undefined

  return w?.data !== undefined
}

export const v2TransitionSpecificity = (t: TransitionV2): number => {
  let score = 0

  if (t.when.timeGreaterThan !== undefined) score += 1

  const topTypes = new Set(t.when.eventsMatching?.events.map(e => e.type) ?? [])
  score += topTypes.size

  const org = t.when.data?.organisation

  if (org) {
    score += V2_ORGANISATION_FIELDS.filter(k => org[k] !== undefined).length
  }

  const dataEvents = t.when.data?.eventsMatching?.events ?? []
  const seenDataTypes = new Set<string>()
  for (const ev of dataEvents) {
    if (!seenDataTypes.has(ev.eventType)) {
      seenDataTypes.add(ev.eventType)
      score += ev.payload.length
    }
  }

  return score
}
